import { type FunctionComponent, useState } from 'react';

import { Input } from '@dr.pogodin/react-utils';

type ThemeT = Exclude<Parameters<typeof Input>[0]['theme'], undefined>;

type PropsT = {
  label: string;
  placeholder?: string;
  setValue: (value: string) => void;
  theme?: ThemeT;
  validationError?: string;
  validator: (value: string) => boolean;
  value: string;
};

const InputWithValidation: FunctionComponent<PropsT> = ({
  label,
  placeholder,
  setValue,
  theme,
  validationError,
  validator,
  value,
}: PropsT) => {
  const [error, setError] = useState('');
  const isValid = validator(value);
  return (
    <Input
      error={error}
      label={label}
      onBlur={() => {
        if (!isValid) {
          setError(validationError ?? `Not a valid ${label.toLowerCase()}`);
        }
      }}
      onChange={(e) => {
        const { value: newValue } = e.target;
        setValue(newValue);
        if (error && validator(newValue)) setError('');
      }}
      placeholder={placeholder}
      theme={theme}
      value={value}
    />
  );
};

export default InputWithValidation;
